// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3yusq","title":"ClientInsurance_title__3xNDP","itemText":"ClientInsurance_itemText__1QjqV"};